// eslint-disable-next-line import/no-cycle
import AsyncROUploader from './AsyncROUploader';
import AsyncSOUploader from './AsyncSOUploader';
import EODeliver from './EODeliver';
import EODispatch from './EODispatch';
import PO from './PO';
import POAllocation from './POAllocation';
import ROCreate from './ROCreate';
import SOAppointment from './SOAppointment';
import SODeliver from './SODeliver';
import SODispatch from './SODispatch';
import { BulkUpload } from '../TrustBasket';

const bulkMenu = {
  BULK_UPLOAD_TB: { path: 'trustbasket', element: <BulkUpload /> },
  BULK_UPLOAD_PO: { path: 'po', element: <PO /> },
  BULK_UPLOAD_PO_ALLOCATION: { path: 'po-allocation', element: <POAllocation /> },
  BULK_UPLOAD_SO_APPOINTMENT: { path: 'so-appointment', element: <SOAppointment /> },
  BULK_UPLOAD_SO_DISPATCH: { path: 'so/:type/:id?', element: <AsyncSOUploader /> },
  BULK_UPLOAD_SO_DELIVER: { path: 'so/:type/:id?', element: <AsyncSOUploader /> },
  BULK_UPLOAD_RO_CREATE: { path: 'ro-create/:type', element: <ROCreate /> },
  BULK_UPLOAD_RO_CREATE_ID: { path: 'ro-create/:type/:id', element: <ROCreate /> },
  BULK_UPLOAD_RO_OPERATION: {
    path: 'ro/:type',
    element: <AsyncROUploader />
  },
  BULK_UPLOAD_RO_OPERATION_ID: {
    path: 'ro/:type/:id',
    element: <AsyncROUploader />
  },
  BULK_UPLOAD_EO_DISPATCH: { path: 'eo-dispatch', element: <EODispatch /> },
  BULK_UPLOAD_EO_DISPATCH_ID: { path: 'eo-dispatch/:id', element: <EODispatch /> },
  BULK_UPLOAD_EO_DELIVER: { path: 'eo-deliver', element: <EODeliver /> },
  BULK_UPLOAD_EO_DELIVER_ID: { path: 'eo-deliver/:id', element: <EODeliver /> }
};

const GET_BULK_UPLOADER_PATH = (groups) => {
  let paths = [];
  groups?.forEach((grp) => {
    if (bulkMenu[grp]) paths.push(bulkMenu[grp]);
  });

  paths = [
    ...paths,
    bulkMenu.BULK_UPLOAD_RO_OPERATION_ID,
    bulkMenu.BULK_UPLOAD_RO_OPERATION,
    bulkMenu.BULK_UPLOAD_RO_CREATE,
    bulkMenu.BULK_UPLOAD_RO_CREATE_ID,
    bulkMenu.BULK_UPLOAD_EO_DISPATCH,
    bulkMenu.BULK_UPLOAD_EO_DISPATCH_ID,
    bulkMenu.BULK_UPLOAD_EO_DELIVER,
    bulkMenu.BULK_UPLOAD_EO_DELIVER_ID
  ];

  return paths;
};

export default GET_BULK_UPLOADER_PATH;
